import { render, staticRenderFns } from "./EventApprovalCard.vue?vue&type=template&id=2e9a9991&scoped=true"
import script from "./EventApprovalCard.vue?vue&type=script&lang=js"
export * from "./EventApprovalCard.vue?vue&type=script&lang=js"
import style0 from "./EventApprovalCard.vue?vue&type=style&index=0&id=2e9a9991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a9991",
  null
  
)

export default component.exports